import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

const commandOptions = [
  { label: "Charge On", command: "charge", state: true },
  { label: "Charge Off", command: "charge", state: false },
  { label: "Discharge On", command: "discharge", state: true },
  { label: "Discharge Off", command: "discharge", state: false },
  { label: "Balance On", command: "balance", state: true },
  { label: "Balance Off", command: "balance", state: false },
  { label: "Emergency On", command: "emergency", state: true },
  { label: "Emergency Off", command: "emergency", state: false },
];

const AdminSettings = () => {
  const [allDevices, setAllDevices] = useState([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [response, setResponse] = useState(null);

  const authToken = localStorage.getItem("accessToken");

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_BASE_URL}api/v1/device/user-devices`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((data) => setAllDevices(data?.data?.allDevices || []));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSendCommand = async (command, state) => {
    if (!selectedDeviceId) {
      toast.error("Select a device first");
      return;
    }

    setIsSending(true);
    setResponse(null);

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/device/send-command/${selectedDeviceId}`,
        { command, state },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      setResponse(data);
      toast.success("Command sent!");
    } catch (error) {
      setResponse(error?.response?.data || { message: error.message });
      toast.error("Failed to send command");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="m-4">
      <h3 className="text-xl font-medium text-slate-700 mb-4">
        Send Battery Command
      </h3>

      <div className="form-control w-full max-w-sm mb-4">
        <label className="label">
          <span className="label-text">Select Device</span>
        </label>
        <select
          className="select select-bordered w-full"
          value={selectedDeviceId}
          onChange={(e) => setSelectedDeviceId(e.target.value)}
        >
          <option value="">-- Select a device --</option>
          {allDevices.map((device) => (
            <option key={device._id} value={device.deviceId}>
              {device.deviceName} ({device.deviceId})
            </option>
          ))}
        </select>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        {commandOptions.map(({ label, command, state }) => (
          <button
            key={label}
            disabled={isSending}
            onClick={() => handleSendCommand(command, state)}
            className="btn btn-primary btn-sm md:btn-md"
          >
            {label}
          </button>
        ))}
      </div>

      {response && (
        <div className="mt-4">
          <h4 className="font-medium mb-2">Device Response</h4>
          <pre className="bg-slate-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
            {JSON.stringify(response, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default AdminSettings;
